import {
  Button,
  DateInput,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  Input,
  SimpleSelect,
} from '@kalos/ui';

import { PAYMENT_STATUS_OPTIONS } from '../../../CustomerDetails/components/constants';
import { useContractsSearchFormContext } from './utils';

/** The select can't hold an empty value, so "-- All --" has its own and maps to an empty filter. */
const ALL_PAYMENT_STATUSES = 'all';
const PAYMENT_STATUS_SELECT_OPTIONS = [
  { value: ALL_PAYMENT_STATUSES, label: '-- All --' },
  ...PAYMENT_STATUS_OPTIONS.map((status) => ({ value: status, label: status })),
];

/**
 * The search fields. `inSheet` renders them for the phone filter sheet: one column, no form of
 * their own (the sheet is the form) and no Reset (the sheet has Reset filters).
 */
const ContractsSearchForm = ({ inSheet = false }: { inSheet?: boolean }) => {
  const form = useContractsSearchFormContext();
  const Fields = inSheet ? 'div' : 'form';
  return (
    // intentionally ignored as values are used as they are typed in
    <Fields
      className={
        inSheet
          ? 'flex flex-col gap-4'
          : 'grid grid-cols-2 place-content-center items-end gap-x-4 gap-y-3 lg:grid-cols-6'
      }
      {...(inSheet ? {} : { onSubmit: form.handleSubmit(console.log) })}
    >
      <FormField
        control={form.control}
        name="number"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Contract Number</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="lastName"
        render={({ field }) => {
          return (
            <FormItem>
              <FormLabel>Last Name</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
            </FormItem>
          );
        }}
      />
      <FormField
        control={form.control}
        name="businessName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Business Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="dateStarted"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Contract Start Date</FormLabel>
            <DateInput value={field.value} onChange={field.onChange} />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="dateEnded"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Expiration Date</FormLabel>
            <DateInput value={field.value} onChange={field.onChange} />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Notes</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="paymentTerms"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Payment Terms</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="paymentStatus"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Payment status</FormLabel>
            <FormControl>
              {/* "-- All --" is the way back to any status; the filter's value for it is empty. */}
              <SimpleSelect
                values={PAYMENT_STATUS_SELECT_OPTIONS}
                selectedValue={field.value || ALL_PAYMENT_STATUSES}
                onChange={(value) => field.onChange(value === ALL_PAYMENT_STATUSES ? '' : value)}
              />
            </FormControl>
          </FormItem>
        )}
      />
      {!inSheet && (
        <Button
          type="reset"
          variant="outline"
          className="mt-auto max-w-max"
          onClick={() => form.reset()}
        >
          Reset
        </Button>
      )}
    </Fields>
  );
};

export default ContractsSearchForm;
